import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import LayoutRecord from 'PreviewRecords/LayoutRecord';
import { updateLayout } from 'PreviewActions';

import Select from 'SharedComponents/WveInputs/style';

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding-top: 5px;
`;

const WveSelect = styled(Select)`
  margin-right: auto;
  width: 100%;
  max-width: none;
`;

class LayoutSelector extends Component {
  handleChange = (event) => {
    const { updateLayout } = this.props; // eslint-disable-line no-shadow
    const selectedLayout = event.value;
    updateLayout(selectedLayout);
  };
  render() {
    const { activeLayout, availableLayouts } = this.props;
    const { handleChange } = this;

    const options = availableLayouts.map(layout => ({ label: layout.name, value: layout.key })).toIndexedSeq().toArray();
    const selectedOption = activeLayout ? activeLayout.key : options[0];
    const disabled = (activeLayout === null);

    return (
      <Row>
        <WveSelect
          value={selectedOption}
          options={options}
          searchable={false}
          clearable={false}
          onChange={handleChange}
          disabled={disabled}
        />
      </Row>
    );
  }
}

LayoutSelector.propTypes = {
  availableLayouts: PropTypes.object,
  activeLayout: PropTypes.instanceOf(LayoutRecord),
  updateLayout: PropTypes.func,
};

LayoutSelector.defaultProps = {
  activeLayout: null,
  availableLayouts: [],
  updateLayout: () => {},
};

const mapDispatchToProps = dispatch => ({
  updateLayout: artboard =>
    dispatch(updateLayout(artboard)),
});

export default connect(null, mapDispatchToProps)(LayoutSelector);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/LayoutSelector/LayoutSelector.jsx